export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block px-4 py-2 border border-purple-200 rounded-full mb-8">
              <span className="text-purple-600 text-xs uppercase tracking-wider">About BRATELI DOO</span>
            </div>
            
            <h2 className="text-5xl font-bold mb-6">
              <span className="text-gray-900 block">Expert Team 💼</span>
              <span className="text-purple-400 block mt-2">Building Tomorrow</span>
            </h2>
            
            <p className="text-gray-600 text-lg leading-relaxed mb-8 max-w-lg">
              We are a dedicated team of iOS development specialists committed to creating innovative mobile solutions. Our focus on security, performance, and user experience drives everything we do. From VPN protection to device optimization, we build apps that make a difference in users' daily lives.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-purple-50 rounded-lg flex-shrink-0">
                  <i className="ri-shield-check-line text-2xl text-purple-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-1">Security First</h3>
                  <p className="text-gray-600 text-sm">Advanced encryption and privacy protection in every application</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-purple-50 rounded-lg flex-shrink-0">
                  <i className="ri-speed-line text-2xl text-purple-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-1">Performance Optimized</h3>
                  <p className="text-gray-600 text-sm">Lightning-fast apps that enhance device capabilities</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-purple-50 rounded-lg flex-shrink-0">
                  <i className="ri-user-heart-line text-2xl text-purple-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-1">User-Centric Design</h3>
                  <p className="text-gray-600 text-sm">Intuitive interfaces that users love</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/99b5a91c511557aa0152e9d0c4edd9f7.jpg"
                alt="Team collaboration"
                className="rounded-2xl shadow-2xl w-full h-auto object-cover"
              />
              <div className="absolute -bottom-8 -left-8 w-48 h-48 bg-purple-100 rounded-2xl -z-10"></div>
              <div className="absolute -top-8 -right-8 w-32 h-32 bg-teal-100 rounded-2xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}